import Swiper from 'swiper';
import {Navigation, Pagination, Autoplay} from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import { Fancybox } from "@fancyapps/ui/dist/fancybox/";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

document.addEventListener('DOMContentLoaded', function () {

    Fancybox.bind("[data-fancybox]", {
        Toolbar: {
            display: {
                left: ["infobar"],
                middle: [],
                right: ["close"],
            },
        },
    });

    const swiperHeroEl = document.querySelector('.swiper-hero');
    if (swiperHeroEl) {
        const progressCircle = document.querySelector(".autoplay-progress svg");
        const progressContent = document.querySelector(".autoplay-progress span");
        const swiperHero = new Swiper('.swiper-hero', {
            loop: true,
            modules: [Pagination, Autoplay],
            autoplay:
                {
                    delay: 5000,
                },
            pagination: {
                el: ".swiper-pagination-hero",
            },
            breakpoints: {
                320: {
                    slidesPerView: 1,
                }
            },
            on: {
                autoplayTimeLeft(s, time, progress) {
                    progressCircle.style.setProperty("--progress", 1 - progress);
                    progressContent.textContent = `${Math.ceil(time / 1000)}s`;
                }
            }
        });
    }

    const swiperOpportunities = new Swiper('.swiper-opportunities', {
        loop: true,
        modules: [Navigation],
        navigation: {
            nextEl: ".swiper-next-opportunities",
            prevEl: ".swiper-prev-opportunities",
        },
        breakpoints: {
            320: {
                slidesPerView: 1,
            },
            1024: {
                slidesPerView: 2,
                spaceBetween: 30
            }
        }
    });

    setTimeout(() => {
        require("../components/FormRefiere");
        // require("./modal_promocion");
    }, 2000);

});
